<template>
   <DashboardAffiliate msg="Welcome to Dashboard ( Home )" v-if="com_user_type_access([2])"/>
   <Dashboard msg="Welcome to Dashboard ( Home )" v-else/>
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard/Dashboard.vue";
import DashboardAffiliate from "@/components/Dashboard/DashboardForAffiliate.vue";

export default {
  name: "Home",
  components: {
    Dashboard,
    DashboardAffiliate,
  },
  data() {
    return {
    }
  },
  created(){
  
  }
};
</script>
